import React from "react"
import { useTranslation } from "react-i18next"

const StatCard = ({ label, value }) => (
  <div className="bg-white rounded-2xl border border-[#E7EAEF] px-4 py-3 flex-1 min-w-[140px]">
    <div className="text-xs text-[#9AA5B4]">{label}</div>
    <div className="text-xl font-semibold text-[#1F2937] mt-1">{value ?? "—"}</div>
  </div>
)

const OverviewStats = ({ overview }) => {
  const { t } = useTranslation()
  if (!overview) return null

  return (
    <div className="flex flex-wrap gap-3 mb-4 md:mb-6">
      <StatCard
        label={t("admin_extension_tokens.stats.users_with_active_token")}
        value={overview.users_with_active_token}
      />
      <StatCard
        label={t("admin_extension_tokens.stats.active_tokens_count")}
        value={overview.active_tokens_count}
      />
      <StatCard
        label={t("admin_extension_tokens.stats.imports_total")}
        value={overview.imports_total}
      />
      <StatCard
        label={t("admin_extension_tokens.stats.imports_last_30_days")}
        value={overview.imports_last_30_days}
      />
    </div>
  )
}

export default OverviewStats
